const tircarnet = {
    getlist: 'tircarnet/getlist',
    add: 'tircarnet/add',
    update: 'tircarnet/update',
    remove: 'tircarnet/remove',
    get: 'tircarnet/get',
    getall: 'tircarnet/getall-by-admin',
    clearcache: 'tircarnet/clear-cache',
}
export default tircarnet
